<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <base-widget icon="shield-lock-fill" title="Canal Confidencial de Denuncias">
    <div class="orangehrm-report-channel-widget">
      <oxd-icon
        name="shield-lock-fill"
        class="orangehrm-report-channel-widget-icon"
      ></oxd-icon>
      <oxd-text tag="p" class="orangehrm-report-channel-widget-text">
        Reporta de forma segura y confidencial cualquier conducta que vaya en
        contra de nuestros valores y políticas
      </oxd-text>
      <oxd-button
        type="button"
        display-type="main"
        label="Realizar Denuncia"
        class="orangehrm-report-channel-widget-button"
        @click="onReport"
      />
    </div>
  </base-widget>
</template>

<script>
import {OxdIcon, OxdButton} from '@ohrm/oxd';
import BaseWidget from '@/orangehrmDashboardPlugin/components/BaseWidget.vue';

export default {
  name: 'ConfidentialReportChannelWidget',

  components: {
    'base-widget': BaseWidget,
    'oxd-icon': OxdIcon,
    'oxd-button': OxdButton,
  },

  methods: {
    onReport() {
      window.open(
        'https://forms.gle/43n66j5eFj89X4Yb9',
        '_blank',
        'noopener,noreferrer',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.orangehrm-report-channel-widget {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  &-icon {
    font-size: 72px;
    height: auto;
    margin-bottom: 1rem;
    color: $oxd-primary-one-color;
  }

  &-text {
    font-size: 12px;
    padding: 0 1rem;
    margin-bottom: 1.5rem;
  }
}
</style>
